import React from 'react';
import './Modal.css';

export default function Modal({ isOpen, message, type, onClose, onConfirm }) {
    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div className={`modal-content ${type}`}>
                <h3>{type === 'success' ? 'نجاح' : 'تنبيه'}</h3>
                <p>{message}</p>
                {onConfirm ? (
                    <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', marginTop: '15px' }}>
                        <button onClick={onConfirm} style={{ background: '#dc3545' }}>نعم</button>
                        <button onClick={onClose} style={{ background: '#6c757d' }}>لا</button>
                    </div>
                ) : (
                    <button onClick={onClose}>حسناً</button>
                )}
            </div>
        </div>
    );
}
